import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { GenericSvg } from "../../assets/svgs/GenericSVG";
import { MainButton } from "../../components/buttons/MainButton";
import { LoadingSpinner } from "../../components/loading/LoadingSpinner";
import {
  PageContainer,
  PageContentContainer,
} from "../../components/PageContainer";
import { InfoText } from "../../components/texts/InfoText";
import { colors } from "../../styles/colors";

export const EmailUnsubscribe = () => {
  const { userId, env } = useParams<{
    userId: string;
    env: "production" | "development";
  }>();

  const [loading, setLoading] = useState(true);
  const [unsubscribeSuccess, setUnsubscribeSuccess] = useState(false);

  const httpsCallableUrl =
    env === "production"
      ? "https://europe-west1-io-physiofit-production.cloudfunctions.net/userEmailUnsubscribe"
      : "https://europe-west1-io-physiofit-development.cloudfunctions.net/userEmailUnsubscribe";

  const callUnsubscribeUserEmail = async (userId: string) => {
    try {
      const response = await fetch(httpsCallableUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ data: { userId } }),
      });

      if (!response.ok) {
        setUnsubscribeSuccess(false);
        console.error("Unsubscribe failed:", response.statusText);
        throw new Error(`Error: ${response.statusText}`);
      }

      const data = await response.json();
      console.log("Unsubscribe successful:", data);
      setUnsubscribeSuccess(true);
    } catch (error) {
      console.error("Error unsubscribing user email:", error);
    }
  };

  const unsubscribeUserEmail = async (userId?: string) => {
    setLoading(true);
    if (!userId) {
      setUnsubscribeSuccess(false);
      setLoading(false);
      return;
    }

    await callUnsubscribeUserEmail(userId).finally(() => setLoading(false));
  };

  useEffect(() => {
    unsubscribeUserEmail(userId);
  }, [userId]);

  const title = loading
    ? "Bitte warten..."
    : unsubscribeSuccess
      ? "Abmeldung erfolgreich"
      : "Abmeldung fehlgeschlagen";

  const subtitle = loading
    ? "Wir bearbeiten deine Abmeldung."
    : unsubscribeSuccess
      ? "Du wurdest erfolgreich von unseren E-Mails abgemeldet."
      : "Es gab ein Problem bei der Abmeldung. Bitte versuche es erneut.";

  const IconComponent = () => {
    if (loading) {
      return <LoadingSpinner color={colors.primary} size={100} />;
    } else if (unsubscribeSuccess) {
      return (
        <GenericSvg
          name="Checkmark"
          width={100}
          height={100}
          primaryColor={colors.success}
        />
      );
    } else {
      return (
        <GenericSvg
          name="Close"
          width={100}
          height={100}
          primaryColor={colors.lightRed}
        />
      );
    }
  };

  return (
    <PageContainer>
      <PageContentContainer>
        <InfoText headline={title} text={[subtitle]} />
      </PageContentContainer>
      <IconComponent />
      {!loading && !unsubscribeSuccess && (
        <MainButton
          text="Erneut versuchen"
          onClick={() => unsubscribeUserEmail(userId)}
        />
      )}
    </PageContainer>
  );
};
